export const OFFICE_DOCUMENT_ACCEPT_TYPES = [
  '.pdf',
  '.doc',
  '.docx',
  '.docm',
  '.xls',
  '.xlsx',
  '.xlsm',
  '.xlsb',
  '.ppt',
  '.pptx',
  '.pptm',
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-word.document.macroEnabled.12',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel.sheet.macroEnabled.12',
  'application/vnd.ms-excel.sheet.binary.macroEnabled.12',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
];

export const ACCEPTED_DOCUMENT_TYPES = OFFICE_DOCUMENT_ACCEPT_TYPES.join(',');

export const ACCEPTED_DOCUMENT_LABEL = 'PDF / Word / Excel / PowerPoint';
